import React, { useEffect } from 'react';
import { classnames } from '../../../utils/classnames';
import Cross from '../cross';

export default function Dialog({ onClose, children, className }) {
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  const onCloseDialog = (e) => {
    if (e.target.className === 'g-modal js-active') {
      onClose()
    }
  }

  return (
    <div className="g-modal js-active" onClick={onCloseDialog}>
      <div className={classnames('g-modal__container', className)}>
        <Cross onClick={onClose} />
        <div className="team__modal-content closed js-content-active">{children && children}</div>
      </div>
    </div>
  );
}
